import request from '@/shared/api/request';

/**
 *
 * Changes the current password to a new one.
 *
 * @returns {Promise}
 */
export const changePassword = (data: {
  old_password: string;
  new_password: string;
  confirm_password: string;
}): Promise<unknown> =>
  request({
    url: '/account/change_password/',
    method: 'PUT',
    data,
  });
